/* assets/cart-drawer-upsell.js */
(function () {
  'use strict';

  // Prevent double-binding if file is accidentally included twice
  if (window.__CU_UPSELL_BOUND__) return;
  window.__CU_UPSELL_BOUND__ = true;

  const SECTIONS = ['cart-drawer']; // we re-render the drawer section

  /* -------------------- Cart helpers -------------------- */
  async function addVariant(variantId, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  }

  async function fetchCartJSON() {
    const r = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-store' }
    });
    if (!r.ok) throw new Error('cart.js failed');
    return r.json();
  }

  async function refreshDrawerInner() {
    // Fetch drawer section HTML (Shopify Sections API)
    const url = new URL(window.location.origin + '/cart');
    url.searchParams.set('sections', SECTIONS.join(','));
    url.searchParams.set('sections_url', window.location.pathname);

    const res = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) throw new Error('sections fetch failed');

    const json = await res.json();
    const html = json['cart-drawer'];
    if (!html) return;

    // Replace inner content of the drawer
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshInner = doc.querySelector('#CartDrawer .drawer__inner');
    const curInner = document.querySelector('#CartDrawer .drawer__inner');
    if (freshInner && curInner) curInner.replaceWith(freshInner);

    // Re-open drawer (in case replacement closed it) & focus close button for a11y
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
    document.querySelector('#CartDrawer .drawer__close')?.focus();

    // Re-init slider in the new DOM
    initUpsellSlider();
  }

  function updateHeaderBubbleFrom(cart) {
    const bubbleRoot = document.getElementById('cart-icon-bubble');
    if (!bubbleRoot) return;

    const count = Number(cart.item_count || 0);
    const bubble = bubbleRoot.querySelector('.cart-count-bubble');

    if (count > 0) {
      if (bubble) {
        const span = bubble.querySelector('span[aria-hidden="true"]');
        if (span) span.textContent = count < 100 ? String(count) : '99+';
      } else {
        bubbleRoot.insertAdjacentHTML(
          'beforeend',
          `<div class="cart-count-bubble">
             <span aria-hidden="true">${count < 100 ? count : '99+'}</span>
             <span class="visually-hidden">Items in cart: ${count}</span>
           </div>`
        );
      }
    } else {
      bubble?.remove();
    }
  }

  async function refreshAfterUpsellAdd() {
    await refreshDrawerInner();
    try {
      const cart = await fetchCartJSON();
      updateHeaderBubbleFrom(cart);
    } catch (e) {
      console.warn('[upsell] bubble update failed', e);
    }
  }

  /* -------------------- Slider logic -------------------- */
  function setSlide(root, idx) {
    const slides = root.querySelectorAll('[data-upsell-slide]');
    slides.forEach((el, i) => {
      if (i === idx) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });

    // arrows
    const prev = root.querySelector('[data-upsell-prev]');
    const next = root.querySelector('[data-upsell-next]');
    prev && (prev.disabled = slides.length <= 1 || idx === 0);
    next && (next.disabled = slides.length <= 1 || idx === slides.length - 1);

    // dots
    root.querySelectorAll('.cu-upsell-dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });

    root.dataset.index = String(idx);
  }

  function initUpsellSlider() {
    document.querySelectorAll('[data-upsell-slider]').forEach((slider) => {
      if (slider.dataset.inited === '1') return;
      slider.dataset.inited = '1';
      setSlide(slider, 0);
    });
  }

  /* -------------------- Button loading helpers -------------------- */
  function startLoading(btn) {
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
  }

  function stopLoading(btn) {
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    btn.dataset.loading = '0';
  }

  /* -------------------- Delegated events -------------------- */
  function bindDelegates() {
    document.addEventListener('click', async (evt) => {
      const target = evt.target;

      // Prev/Next arrows under the card
      const prev = target.closest('[data-upsell-prev]');
      const next = target.closest('[data-upsell-next]');
      if (prev || next) {
        const slider = target.closest('[data-upsell-slider]');
        if (!slider) return;
        evt.preventDefault();
        const current = Number(slider.dataset.index || 0);
        const slides = slider.querySelectorAll('[data-upsell-slide]').length;
        let to = current;
        if (prev) to = Math.max(0, current - 1);
        if (next) to = Math.min(slides - 1, current + 1);
        setSlide(slider, to);
        return;
      }

      // Dots (• • •)
      const dot = target.closest('[data-upsell-dot]');
      if (dot) {
        const slider = dot.closest('[data-upsell-slider]');
        if (!slider) return;
        evt.preventDefault();
        const to = Number(dot.dataset.upsellDot || 0);
        setSlide(slider, to);
        return;
      }

      // Upsell "Add to cart" button
      const btn = target.closest('[data-upsell-add]');
      if (btn && btn.closest('#CartDrawer')) {
        evt.preventDefault();

        const card = btn.closest('.cu-upsell-card');
        let variantId = btn.dataset.defaultVariantId;
        const select = card?.querySelector('[data-upsell-variant-select]');
        const hidden = card?.querySelector('[data-upsell-variant-id]');
        if (select) variantId = select.value;
        if (hidden) variantId = hidden.value;
        if (!variantId) return;

        if (btn.dataset.loading === '1') return; // already loading
        startLoading(btn);
        try {
          await addVariant(variantId, 1);
          await refreshAfterUpsellAdd(); // drawer re-renders; button DOM is replaced
        } catch (err) {
          console.error('[upsell add]', err);
          stopLoading(btn); // restore on error so the user can retry
        }
        return;
      }
    });
  }

  /* -------------------- Boot -------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    bindDelegates();
    initUpsellSlider();
    // When Shopify re-renders sections in the editor or via AJAX, re-init the slider
    document.addEventListener('shopify:section:load', () => initUpsellSlider());
  });
})();
